import { IWorkshop } from './DishObjDto'
import { IRestaurant, IRestaurantRole } from './RestaurantsObjDto'

export enum Role {
  SUPERVISOR = 'SUPERVISOR',
  ACCOUNTANT = 'ACCOUNTANT',
  COOK = 'COOK',
  CONTROLLER = 'CONTROLLER',
  MANAGER = 'MANAGER',
  ADMINISTRATOR = 'ADMINISTRATOR',
}

export enum RoleTranslate {
  SUPERVISOR = 'Управляющий',
  ACCOUNTANT = 'Бухгалтер',
  COOK = 'Повар',
  CONTROLLER = 'Марочница',
  MANAGER = 'Менеджер',
  ADMINISTRATOR = 'Администратор',
}

export interface IRole {
  roleType: (keyof typeof Role)[]
  id: number
  expireDate?: string
  userId: number
  restaurant: IRestaurant
  // workshops: IWorkshop[]
}

export interface IRoleLogin {
  roleType: (keyof typeof Role)[]
  id: number
  restaurant: IRestaurantRole
}

export interface IUserResponseDto {
  id: number
  username: string
  email: string
  phone: number
  userRoles: IRole
  isArchived: boolean
  login: string
}

export interface IUserDto {
  id: number
  username: string
  email: string
  role: IRoleLogin
}
